import { combineReducers } from 'redux';

import acoesUso from './acoesUso/reducer';
import token from './token/reducer';

export default combineReducers({
	acoesUso,
	token,
});
